import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import type {AxiosError} from 'axios'

import {REFRACTORIES_WITH_CUSTOMIZATION_QUERY_KEY} from '../consts'
import type {RefractoryBulkImportResponse, RefractoryBulkUpdateValidationResponse} from '../types'

const BULK_REFRACTORIES_PATH = '/plants/refractory-product-data-catalog/refractories/bulk'
const BULK_TEMPLATE_PATH = `${BULK_REFRACTORIES_PATH}/template`
const BULK_VALIDATE_PATH = `${BULK_REFRACTORIES_PATH}/validate`

const createFileFormData = (file: File): FormData => {
  const formData = new FormData()
  formData.append('file', file)
  return formData
}

export const downloadRefractoryBulkTemplate = async (): Promise<Blob> => {
  const response = await ApiClient.axiosInstance.get<Blob>(BULK_TEMPLATE_PATH, {
    responseType: 'blob'
  })
  return response.data
}

export const useValidateRefractoryBulk = () =>
  useMutation<RefractoryBulkUpdateValidationResponse, AxiosError, File>({
    mutationFn: async (file) => {
      const response = await ApiClient.axiosInstance.post<RefractoryBulkUpdateValidationResponse>(
        BULK_VALIDATE_PATH,
        createFileFormData(file),
        {headers: {'content-type': 'multipart/form-data'}}
      )
      return response.data
    }
  })

export const useImportRefractoryBulk = () => {
  const queryClient = useQueryClient()

  return useMutation<RefractoryBulkImportResponse, AxiosError, File>({
    mutationFn: async (file) => {
      const response = await ApiClient.axiosInstance.post<RefractoryBulkImportResponse>(
        BULK_REFRACTORIES_PATH,
        createFileFormData(file),
        {headers: {'content-type': 'multipart/form-data'}}
      )
      return response.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === REFRACTORIES_WITH_CUSTOMIZATION_QUERY_KEY
      })
    }
  })
}
